import React from 'react';
import moment from 'moment-timezone';

import { types } from '../../../constants/filter';

const processDate = (val, zoneId) => moment.tz(val, zoneId).format('YYYY-MM-DD');

const preprocessValue = (type, value, options) => {
  if (value instanceof Array) {
    return value.map((v) => preprocessValue(type, v, options)[0]);
  }

  if (type === types.DATE) {
    return [processDate(value, options.zoneId)];
  }

  return [value];
};

const CompoundExecutionStepFilterFieldValues = ({ type, value, zoneId }) => {
  const preprocessedValue = preprocessValue(type, value, { zoneId });
  let wrappedValue = preprocessedValue.map((v) => (
    <div key={v} style={{ color: 'black', fontWeight: 'bold' }}>{`${v}`}</div>
  ));

  if (wrappedValue.length > 1) {
    const tmp = [];

    let i = 1;
    for (; i < wrappedValue.length; ++i) {
      tmp.push(wrappedValue[i - 1]);
      // TODO: add key property
      tmp.push(
        <div style={{ marginRight: 5 }} key={`${preprocessedValue[i - 1]}-comma`}>
          ,
        </div>
      );
    }

    tmp.push(wrappedValue[i - 1]);
    wrappedValue = tmp;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'row wrap',
        alignContent: 'flex-start',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
      }}
    >
      {wrappedValue}
    </div>
  );
};

export default CompoundExecutionStepFilterFieldValues;
